// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2PSul","content":"styles_content__2vPSw","checkbox":"styles_checkbox__1e_4Z","checkboxLabel":"styles_checkboxLabel__uivs-"};